export default __webpack_public_path__ + "images/2966c05fc878bfd5c8803158702b11e9-KDT_Logo_DKT_weiss.svg";